<template>
  <div>
    <div class="">
      <b-row
        class="container-border"
        v-for="(item, index) in groupList"
        :key="index"
      >
        <b-col>
          <div class="d-flex align-items-end">
            <BarProgress :data="item" />
            <div class="my-2 ml-3">
              <b-dropdown
                size="lg"
                right
                variant="link"
                toggle-class="text-decoration-none"
                class="dropdown-unknow"
                no-caret
              >
                <template #button-content>
                  <font-awesome-icon class="my-auto" icon="ellipsis-v" />
                </template>
                <b-dropdown-item @click="$emit('handleCreateIntent', item)"
                  >Create Intent</b-dropdown-item
                >
                <b-dropdown-item @click="openModalDelete(item)"
                  >Remove Keyword</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </b-col>
        <b-col class="right-line">
          <GroupText
            :dataList="item.word"
            :isShowAll="isShowAll"
            v-on:setShowAllGroupText="setShowAllGroupText"
          />
        </b-col>
      </b-row>
    </div>
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
  </div>
</template>

<script>
import BarProgress from "@/views/pages/chat-analysis/components/BarProgress";
import GroupText from "@/views/pages/chat-analysis/components/GroupText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  components: {
    BarProgress,
    GroupText,
    ModalLoading,
    ModalAlertConfirm,
  },
  props: {
    groupList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      isShowAll: false,
      groupId: "",
      requestDeleteKeyword: {
        groupId: null,
      },
      modalMessage: "",
    };
  },
  methods: {
    openModalDelete(value) {
      console.log(value);
      this.requestDeleteKeyword.groupId = value.id;
      this.modalMessage = "คุณต้องการลบ " + value.nameKeyword + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      this.$emit(
        "onRemoveGroupKeyword",
        true,
        this.requestDeleteKeyword.groupId
      );
    },
    setShowAllGroupText() {
      this.isShowAll = !this.isShowAll;
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-18 {
  font-size: 18px;
}

.right-line {
  border-left: 1px solid #bebebe;
}

.container-border:last-child > .right-line > .grouptext-container {
  border-bottom: none;
}
</style>
